export default __webpack_public_path__ + "static/media/CaviarDreams_Bold.1062ba91.ttf";